import Vue from "vue";
import axios from "axios";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import apiPath from "@/plugins/api";

export const state = () => ({
  state: {
    modalAlertLogin: false,
    profileLists: {},
    formList: {},
    formDetail: {},
    campaignDetail: {},
    respupdateBookingForm: {},
    privilegeList: {},
    respCreateForm: {},
    respUpdateForm: {},
    bookingStatus: {},
    userRegisterForm: {},
    respExport: {},
    fieldtype: [],
  },
});

export const mutations = {
  setModalAlertLogin: async function (state, val) {
    state.modalAlertLogin = val;
  },
  setProfileLists: async function (state, val) {
    state.profileLists = val;
  },
  setFormList: async function (state, val) {
    state.formList = val;
  },
  setFormDetail: async function (state, val) {
    state.formDetail = val;
  },
  setCampaignDetail: async function (state, val) {
    state.campaignDetail = val;
  },
  setRespupdateBookingForm: async function (state, val) {
    state.respupdateBookingForm = val;
  },
  setPrivilegeList: async function (state, val) {
    state.privilegeList = val;
  },
  setRespCreateForm: async function (state, val) {
    state.respCreateForm = val;
  },
  setRespUpdateForm: async function (state, val) {
    state.respUpdateForm = val;
  },
  setBookingStatus: async function (state, val) {
    state.bookingStatus = val;
  },
  setUserRegisterForm: async function (state, val) {
    state.userRegisterForm = val;
  },
  setRespExport: async function (state, val) {
    state.respExport = val;
  },
  setFieldType: async function (state, val) {
    state.fieldtype = val;
  },
};

export const actions = {
  getBookingFieldProfiletypes: async ({ commit }) => {
    await axios.get(`${apiPath}/booking/fieldprofiletype`).then(
      async (data) => {
        commit("setProfileLists", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getBookingList: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/booking/getlist`, payload).then(
      async (data) => {
        commit("setFormList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getBookingReportList: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/booking/getMenuList`, payload).then(
      async (data) => {
        commit("setFormList", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getBookingDetail: async ({ commit }, payload) => {
    await axios.get(`${apiPath}/booking/${payload}`).then(
      async (data) => {
        commit("setFormDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  createBookingFormAnswer: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/booking/createbookinganswer`, payload).then(
      async (data) => {
        commit("setRespupdateBookingForm", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  createBookingFormTicket: async ({ commit }, payload) => {
    await axios
      .post(`${apiPath}/booking/createbookinganswerticket`, payload)
      .then(
        async (data) => {
          commit("setRespupdateBookingForm", data.data);
        },
        (error) => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            commit("setModalAlertLogin", true);
          }
        }
      );
  },
  updateBookingForm: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/booking/updatebookinganswer`, payload).then(
      async (data) => {
        commit("setRespupdateBookingForm", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateBookingFormTicket: async ({ commit }, payload) => {
    await axios
      .post(`${apiPath}/booking/updatebookinganswerticket`, payload)
      .then(
        async (data) => {
          commit("setRespupdateBookingForm", data.data);
        },
        (error) => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            commit("setModalAlertLogin", true);
          }
        }
      );
  },
  getPrivilegeList: async ({ commit }, payload) => {
    await axios
      .post(`${apiPath}/Form/getprivilege/${payload.id}`, payload.filter)
      .then(
        async (data) => {
          commit("setPrivilegeList", data.data);
        },
        (error) => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            commit("setModalAlertLogin", true);
          }
        }
      );
  },
  createBookingForm: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/booking`, payload).then(
      async (data) => {
        commit("setRespCreateForm", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  GetBookingStatus: async ({ commit }) => {
    await axios.get(`${apiPath}/booking/status/default`).then(
      async (data) => {
        commit("setBookingStatus", data.data.detail);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  updateBooking: async ({ commit }, payload) => {
    await axios.put(`${apiPath}/booking`, payload).then(
      async (data) => {
        commit("setRespUpdateForm", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  getBookingUserRegister: async ({ commit }, payload) => {
    await axios
      .post(`${apiPath}/booking/getcampaignuser/${payload.id}`, payload.filter)
      .then(
        async (data) => {
          commit("setUserRegisterForm", data.data);
        },
        (error) => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            commit("setModalAlertLogin", true);
          }
        }
      );
  },
  // exportCampaignForm: async ({ commit }, payload) => {
  //   await axios
  //     .get(`${process.env.VUE_APP_API}/Form/exportcampaignuser/${payload}`, {
  //       responseType: "blob",
  //     })
  //     .then(
  //       (data) => {
  //         commit("setRespExport", data);
  //       },
  //       (error) => {
  //         const code = parseInt(error.response && error.response.status);
  //         if (code === 401) {
  //           commit("setModalAlertLogin", true);
  //         }
  //       }
  //     );
  // },
  getBookingFormDetail: async ({ commit }, payload) => {
    await axios.get(`${apiPath}/Booking/answerdetail/${payload.id}`).then(
      async (data) => {
        commit("setCampaignDetail", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
          commit("setModalAlertLogin", true);
        }
      }
    );
  },
  // getFieldTypes: async ({ commit }) => {
  //   await axios.get(`${apiPath}/Form/fieldtype`).then(
  //     async (data) => {
  //       commit("setFieldType", data.data);
  //     },
  //     (error) => {
  //       const code = parseInt(error.response && error.response.status);
  //       if (code === 401) {
  //         commit("setModalAlertLogin", true);
  //       }
  //     }
  //   );
  // },
};

export default {
  state,
  actions,
  mutations,
};
